module.exports = __webpack_public_path__ + "img/nigeria-coat-of-arms.22d73900.png";